import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { SgTextVariant } from '../sg-text/sg-text.component';
import { SgTooltipPosition } from '../../directives/sg-tooltip/sg-tooltip.model';

@Component({
  selector: 'sg-info-tooltip',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <sg-text
      [variant]="variant"
      [withoutLineHeight]="withoutLineHeight"
      class="wrapper"
      [sgTooltip]="heading"
      [tooltipDescription]="text"
      [tooltipPosition]="tooltipPosition"
      (mouseenter)="hovered = true"
      (mouseleave)="hovered = false">
      <mat-icon class="icon" aria-hidden="true">{{ hovered ? 'info' : 'info_outline' }}</mat-icon>
    </sg-text>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
      }

      .wrapper {
        display: inline-flex;
        cursor: pointer;
      }

      .icon {
        font-size: 1em;
        width: 1em;
        height: 1em;
        color: var(--sg-content-tertiary);
        transition: color 0.2s ease-in-out;
      }

      .wrapper:hover .icon {
        color: var(--sg-content-info-primary);
      }
    `,
  ],
})
export class SgInfoTooltipComponent {
  @Input() heading: string;
  @Input() text: string;
  @Input() variant: SgTextVariant = 'sg-body-medium-bold';
  @Input() tooltipPosition: SgTooltipPosition = 'below';
  @Input('withoutLineHeight') set _withoutLineHeight(value: BooleanInput) {
    this.withoutLineHeight = coerceBooleanProperty(value);
  }

  @HostBinding('attr.title') readonly noNativeTooltip = null;
  @HostBinding('attr.role') readonly role = 'img';
  @HostBinding('attr.aria-label') get ariaLabel(): string {
    return [this.heading, this.text].filter(Boolean).join(': ');
  }

  hovered = false;
  withoutLineHeight = true;
}
